export * from '@primeuix/themes/lara/divider';
export { default } from '@primeuix/themes/lara/divider';
